export default {
  locale: "en-US",
  language: "English",
  menu: {
    i18n: "Internationalization"
  },
  page: {
    supReg: {
      title: "register",
      stepName: [
        "Registration instructions",
        "Notice of Registration",
        "Business ethics agreement",
        "Apply for a username",
        "Supplier basic information\n" + "\n",
        "Contact information",
        "Product information",
        "Bank Information",
        "Historical cooperation Achievements",
        "Qualification documents"
      ],
      contentTitle: [
        "1. Read the registration notice.",
        "2. Read the 《Agreement of Business Ethics and Principles》And agree to the agreement.",
        "3. Apply for a username.",
        "4. Fill in the details and upload the qualification documents(* Required Fields).",
        "5. Submit to the relevant company and waiting for approval."
      ],
      contentP: [
        "",
        'Check "Have read and agree to the Agreement on Compliance with Business Ethics"',
        "Apply for a user name as required, fill in the contact details, and select the recommended unit",
        "Fill in supplier details carefully and upload relevant qualification documents for inquiry",
        'After confirming that the information is correct, click the "Submit" button'
      ]
    },
    supNotice: {
      contentTitle: "Notice of Registration ",
      contentP: [
        '1. Materials Purchasing Management Information System of CCCC (http://ec.ccccltd.cn) is the only legitimate website for trade suppliers and CCCC. CCCC keeps a positive cooperation relationship with suppliers on the basis of "Heart-to-heart business, win-win cooperation".',
        "2. There is no other cost to be beared by suppliers for this registration, and CCCC will not charge to suppliers by means of annual verification, membership, performance assessment, etc. Suppliers must ensure all the registration information shall be real, accurate and updated.",
        "3.In case of system upgrade, the platform operator has the right to extend the end time of bidding and the end time of sale."
      ]
    },
    moralAgree: {
      contentH: "AGREEMENT OF BUSINESS CONDUCT AND ETHICS",
      errMsg: [
        "Please check have read and agree to abide by the Business Ethics Agreement."
      ],
      contentCheckbox: ["I have read the Terms & Conditions and accept them"]
    },
    applyUsername: {
      contentTitle: {
        loginInfo: "User information(* Required Fields)",
        contacts: "Contact information(* Required Fields)",
        reCompany: "Recommended by(* Required Fields)",
        promptTitle: "This supplier has completed platform registration",
        promptContent: "You can go to the login page and use your account credentials (username and password) to log in; if you forget your account and password, you can submit a retrieval request",
        promptContent1: "Your supplier registration application was rejected by the initial recommender. Please log in with your username and password on the login page to check the rejection reasons, make changes, and resubmit. If you've forgotten your login details, you can request a retrieval.",
      },
      contentTitles: {
        contactsWay:
          "Telephone, mobile number and email address are important contact ways, please provide accurate information for us to follow-up.",
        reCompanyMsg:
          "The recommendation company is responsible for approving the supplier registration. Please choose carefully"
      },
      contentLabel: {
        supName: "Supplier name:",
        id: "username:",
        authCode: "Code",
        pwd: "Password:",
        repwd: "Confirmed password:",
        contacts: "Contacts:",
        contactsTel: "Telephone:",
        contactsFax: "Fax:",
        contactsMobile: "Mobile Number:",
        contactsInfo: "Contact information",
        contactsEmail: "Email:",
        provinces: "Province, City/Town, District:",
        reCompany: "Recommended by:",
        mobile: "Mobile Number:",
        ID: "Cerification Number:",
        username: "Username",
        type: "Cerification Type:",
        IDFront: "Cerification front:",
        IDBack: "Cerification back:"
      },
      inputPlc: {
        supNameMSg: "Please enter the supplier name",
        idMsg: "Please enter your username",
        authCodeMsg: "Please enter the SMS verification code",
        pwdMsg: "8 characters or longer. Include 1 number at least",
        repwdMsg: "Please enter your password again",
        contactsMsg: "Please enter the name",
        contactsTelMsg:
          "Please enter the country code - area code - phone number",
        contactsFaxMsg: "Please enter the area code - fax number",
        contactsMobileMsg: "Please enter the country code - mobile number",
        contactsEmailMsg: "Please enter E-mail",
        IDMsg:
          "Please enter the contact ID number/foreign social security number",
        IDMsgValidate: "Please enter the correct ID number/foreign social security number",
        provincesMsg: "",
        reCompanyMsg: "Please select the recommended unit"
      },
      inputRules: {
        pwdMsg1: "",
        pwdMsg2: "",
        repwdMsg: "Your confirmed password and new password do not match.",
        contactsMsg: "Name",
        contactsTelMsg: "Please enter the country code - mobile number.",
        contactsFaxMsg: "",
        contactsMobileMsg: "",
        contactsEmailMsg: "The email format is incorrect",
        provincesMsg: "Please select a province or region",
        sliderMsg: "Please enter your mobile phone number first",
        reCompanyMsg: "The recommended unit cannot be empty",
        reCompanyMsg1: "The recommended unit does not exist",
        reCompanyMsg2: "Please enter non-group headquarters",
        supNameMSg: "The supplier name cannot be empty",
        supNameMSg1: "The vendor name already exists",
        codemsg: "The code cannot be empty",
        mobilemsg: "The mobile phone number cannot be empty",
        mobilemsg1: "The mobile number already exists"
      },
      btn: {
        getCode: "Get verification code",
        msg1: "Hold down the slider and drag it to the far right",
        msg2: "Pass the verification",
        msg3: "Loading...",
        msg4: "Verification fail",
        msg5: "哎呀出错了，点击",
        msg6: "刷新",
        msg7: "再来一次（英文）",
        msg8: "网络不给力，请",
        msg9: "点击刷新（英文）",
        msg10: "I have registered to check the approval progress",
        promptbutton1: "Retrieve password",
        promptbutton2: "Log in now"
      },
      dialogMsg: {
        msg1: "The recommended unit you have selected is",
        msg2:
          ",The recommending unit is responsible for reviewing your company's registration information. Please check carefully to avoid mistakes!",
        title: "tips"
      }
    },
    supInfo: {
      contentTitle: {
        basicInfo: "Basic information (* Required Fields)",
        producer: "Manufacturer(fill in)",
        dealer: "Distributor(fill in)"
      },
      contentLabel: {
        supName: "Supplier name:",
        abbreviation: "Abbreviation:",
        supType: "Supplier type:",
        hisName: "Historical name:",
        isForeign: "Whether it is a foreign trade supplier",
        isInside: "CCCC internal enterprise:",
        isThree: "Whether the three syndromes are in one",
        unifyCode: "Unify the social credit code",
        GATunifyCode: "Unify the social credit code",
        framework: "",
        organization: "",
        dutyParagraph: "Tax Identification number (TIN):",
        domicile: "Registered address:",
        businessAddress: "Office location:",
        postcode: "Postcode:",
        registeredCapital: "Registered Capital/Paid-up Capita(Ten thousand yuan):",
        currency: "Currency:",
        capital: "Paicl-up capital:",
        UniProperty: "Unit property:",
        companyType: "Type of company:",
        businessScope: "Scope of business:",
        foundingTime: "Date of Establishment:",
        businessTerm: "Operation period: ",
        organizationChart: "Organizational structure and marketing network:",
        companyName: "The name of the group company:",
        companyProfile: "Company profile:",
        capacity: "capacity:",
        processStatus: "Technological status:",
        manufacturer: "Name of the manufacturer of the product being sold:",
        qualification: "Sales agent qualification:",
        userInfo: "User information",
        country: "Coutry of Registration:",
        business:
          "Certificate of Incorporation Number/Business License Number: ",
        organiza: "Branches and contact information:",
        unitCategory: "Company category:",
        abroadSocialSecurity: "Social security number/Identification"
      },
      inputPlc: {
        supName: "please enter Supplier name",
        abbreviation: "Please enter abbreviation",
        unitCategory: "Please enter the company category",
        hisName: "Please enter a history name",
        choose: "Please select",
        yes: "yes",
        no: "no",
        unifyCode: "Please enter a unified Social credit code",
        GATunifyCode: "Please enter a unified Social credit code",
        framework: "",
        chooseDate: "Select date",
        dutyParagraph: "Please enter your tax ID",
        domicile: "Please enter address",
        businessAddress: "Please enter the office address",
        UniProperty: "Please select the unit nature",
        postncode: "please enter postcode",
        registeredCapital: "Please enter registered capital",
        capital: "Please enter paid-in capital",
        input: "please enter",
        country: "Please select country",
        business: "Please enter business license number",
        organiza: "Please enter the branch office and contact information",
        personal: "individual",
        company: "unit",
        abroadSocialSecurity:
          "Please enter your social security number/Identification"
      },
      inputRules: {
        supType: "Please select a vendor type",
        choose: "Please choose yes or no",
        chooseDate: "Please fill in the date",
        chooseCurrency: "Currency information cannot be empty",
        conpanyType: "please choose company type",
        businessScope: "Please enter the scope of business",
        foundingTime: "Please select the establishment time",
        businessTerm: "please choose Operation period",
        max: "max no six",
        postcode: "postcode is err",
        organizationChart:
          "Please enter organizational structure and marketing network",
        companyProfile: "Please enter company profile",
        country: "Please select country",
        unitCategoryType: "Please select a unit or individual",
        abroadSocialSecurity:
          "Please enter your social security number/Identification"
      }
    },
    contactInfo: {
      contentTitle: { contactsInfo: "Contact information(* Required Fields)" },
      contentLabel: {
        legalName: "Name of Owner:",
        controlAgent: "Actual controlling agent",
        xuhao: "No.",
        controlType: "Real control type",
        controlId: "Control subject code or certificate number",
        legalMobile: "Legal representative mobile phone",
        legalID: "Owner/Authorized Person identification",
        saleID: "Sales person ID number/overseas social security number",
        legalTel: "Legal representative landline telephone:",
        legalFax: "Facsimile of legal representative:",
        legalEmail: "Legal representative email address:",
        market: "Sales person in charge:",
        marketMobile: "Mobile Number:",
        marketTel: "Telephone:",
        marketFax: "Fax:",
        marketEmail: "Email:",
        web: "Company website:",
        DJG: "Chief executive officer",
        DJGT: "Types of directors and supervisors",
        DJGN: "Names of directors, supervisors and officials",
        DJGID: "Certificate number of directors and supervisors"
      },
      inputPlc: {
        legalNameMsg: "Please enter the legal representative name",
        saleID:
          "Please enter the sales person ID number/overseas social security number",
        legalMobileMsg:
          "Please enter the mobile phone number of the legal representative",
        legalTelMsg:
          'Please enter the legal representative area code and landline telephone number, for example, "010-********".',
        legalID:
          "Please enter the legal representative ID number/overseas social security number",
        legalFaxMsg:
          'Please enter the legal representative area code and fax number, e.g. "010-********"',
        legalEmailMsg: "Please enter the legal representative email address",
        marketMsg: "Please enter the name of the sales manager",
        marketMobileMsg:
          "Please enter the mobile phone number of the sales director",
        marketTelMsg:
          'Please enter the area code and landline phone number of the sales officer, e.g. "010-********"',
        marketFaxMsg:
          'Please enter the sales Officer area code and fax number, e.g. "010-********"',
        marketEmailMsg: "Please enter the email address of the sales manager",
        webMsg: "Please enter the website address"
      },
      inputRules: {
        mobileMsg: "The format of the mobile phone number is incorrect",
        legalTelMsg:
          "The fixed-line telephone format of the legal representative is incorrect (format: area code + number, such as 010-1234567)",
        legalFaxMsg:
          "The fax format of the legal representative is incorrect (format: area code + number, such as 010-1234567)",
        marketTelMsg:
          "Incorrect format of sales person's landline (format: area code + number, such as 010-1234567)",
        marketFaxMsg:
          "Incorrect fax format (format: area code + number, such as 010-1234567)",
        emailMsg: "The email format is incorrect"
      }
    },
    productInfo: {
      contentTitle: { productInfo: "Product information" },
      tableTh: {
        productCode: "Product code no",
        productName: "Product name",
        productTrademark: "Product trademark",
        remark: "Remarks",
        operation: "Operation"
      },
      btn: {
        add: "Add",
        newAdd: "Add",
        batchDel: "batch delete",
        del: "Delete",
        cancel: "Cancel",
        confirm: "Confirm"
      },
      dialog: {
        info: "tips",
        title: "Equipment and materials selection",
        inp: "please enter",
        nextMsg: "Please select at least one product information"
      },
      delInfo: {
        batchDelInfo: "Please select at least one product to deleted",
        delInfo:
          "This action will permanently delete the file, do you want to continue?",
        confirmDel: "Successfully deleted",
        cancelInfo: "undeleted"
      }
    },
    financeInfo: {
      contentTitle: { financeInfo: "Bank Information(* Required Fields)" },
      contentLabel: {
        bankAccount: "Bank Account Number:",
        depositBank: "Name of Bank:",
        bankAccountName: "Bank Account Name:",
        bankAddress: "Address of Bank:",
        beneficiary: "beneficiary's address:",
        swiftCode: "Swift code:",
        isWhether:
          "Whether to accept payment by L / C ?\n" + "( Letter of Credit):"
      },
      inputPlc: {
        bankAccountMsg: "Please enter your bank account number",
        depositBankMsg: "Please enter your bank",
        bankAccountNameMsg: "Please enter your bank account name",
        bankAddressMsg: "Please enter the bank address",
        beneficiaryMsg: "Please enter the recipient's address",
        swiftCodeMsg: "Please enter bank international code",
        isWhetherMsg: "Please choose yes or no"
      }
    },
    hisCooperation: {
      contentTitle: { hisCooperation: "Historical cooperation achievements" },
      contentLabel: {
        cooperationCompany: "Cooperative enterprise:",
        cooperationPerformance: "Achievements of cooperation with CCCC:",
        peerCooperation:
          "Cooperation performance with enterprises in the same industry:",
        remark: "remark:"
      },
      inputPlc: {
        input: "please enter",
        cooperationCompanyMsg: "Please enter a partner company"
      }
    },
    qualificationFile: {
      contentTitle: {
        qualificationFile: "Company Qualification Documents(* Required Fields)"
      },
      contentTitles: {
        hintMsg1:
          "Tip: Please upload the original scanned copy, the image file should be less than ",
        hintMsg2: "15 ",
        hintMsg3: "M,and other files should be less than ",
        hintMsg4: "30 M"
      },
      tableTh: {
        name: "Attachment name",
        type: "Type",
        file: "Filename",
        enclosureNotation: "Attachment description",
        operation: "Operation",
        input: "please enter",
        size: "附件大小（英文）"
      },
      tableTd: {
        businessLicense: "Certificate of Incorporation/Business License copy",
        identityCard: "Owner/Authorized Person identification",
        frameworkImg: "Organization code certificate picture",
        taxationImg: "Tax registration certificate",
        taxationImg2: "（including VAT general taxpayer red seal page）",
        qualityControl: "Quality management system documentation",
        specialIndustry: "Special certificate",
        organizationChart:
          "Organizational structure and marketing network related documents",
        companyQualification: "Certificate of Award",
        productionLicence: "Production certificate",
        distributiontImg: "Distribution agent qualification certificate",
        financialStatement:
          "Financial statements (audited financial statements for the previous year)",
        cooperationFile:
          "Customs declaration registration (customs registration code)",
        businessLicenses: "business certificate",
        environmentalManagement: "Environment management system documentation",
        healthySafety:
          "Health management system documentation(Multiple images need to be merged and uploaded) ",
        transportation: "transportation license",
        otherFiles: "Others",
        img: "Picture",
        file: "File"
      },
      btn: { uploading: "Upload", del: "Delete" },
      info: {
        uploadErr1:
          "Supported format of uploaded images:.jpg.png.jpeg.gif.webp Each does not exceed 15M",
        uploadErr2: "Upload image size cannot exceed 15M!",
        uploadErr3:
          "Support format for upload files:.xls.xlsx.doc.docx.pdf each not exceeding 15M",
        uploadErr4: "Upload file size cannot exceed 30M!",
        delErr: "Please upload the file first",
        subErr1: "The picture of the business license copy cannot be empty",
        subErr2: "The organization code certificate picture cannot be empty",
        subErr3: "The tax registration certificate picture cannot be empty",
        subErr4: "The transportation permit file cannot be empty",
        subErr5: "The copy of the legal representative's ID card cannot be blank",
        dialog1:
          "Please confirm that the information is valid. Are you sure to submit it?",
        dialog2:
          "You have successfully submitted the registration application information. Please be patient and wait for the audit。",
        sameFile: "Please do not upload files with the same name!",
        upload1: "File uploaded successfully"
      },
      file: {
        download: "download",
        clickdownload: "Click to download",
        tip:
          "(including the red seal page of value-added tax general taxpayers)"
      }
    },
    mobileValidate: {
      title1: { name: "Username", psd: "Password" },
      inputPlc: {
        mobile: "Please enter the country code - mobile number",
        name: "Please enter your username",
        psd: "Please enter passwor"
      },
      inputRules: {
        mobile: "Please enter the correct phone number",
        code: "Please enter a six-digit verification code"
      },
      title: {
        title:
          "Use the account password to complete identity authentication and check the registration approval progress"
      },
      btn: { code: "Send verification code", sub: "Submit for certification" },
      msg: {
        q: "Can't receive SMS verification code？",
        a:
          "Please check the mobile phone network and verify whether the mobile phone blocks system SMS. If it is normal, please obtain it again or try again later.",
        msg1: "当前手机号未注册供应商（英文）"
      }
    },
    foreignSupRegDetail: {
      btn: {
        perfect1: "Improve the profile information",
        recall: "Withdraw an application",
        perfect2: "Modify information"
      },
      msg: {
        msg1:
          "The registration information of your company has been approved by",
        msg2:
          ", and the supplier is not allowed to withdraw the registration application",
        msg3:
          "The registration information of your company has not been approved, are you sure to withdraw the registration application",
        msg4: "Successful withdrawal of application",
        msg5: "The withdrawal application has been cancelled"
      }
    },
    approval: {
      title: {
        title: "Approval record",
        title1: "Instructions",
        title2: "conclusion",
        title3: "Opinion"
      },
      msg: { msg1: "审批中（英文）", msg2: "暂无数据（英文）" }
    },
    validateMsg: {
      validateIDCard1: "Abnormal verification of contact ID card",
      validateIDCard2: "Abnormal verification of legal representative's ID card",
      validateIDCard3: "Abnormal verification of salesperson's ID card",
      validateIDCard4: "Abnormal verification of directors, supervisors, and senior management personnel's ID card",
      validateIDCard5: "The uploaded ID card information does not match the legal person's information, please re-upload",
      validateIDCard6: "The document type for directors, supervisors, and senior management personnel is mandatory"
    },
    // 英文 获取验证码
    validateEmail: {
      // 联系人邮箱不能为空！ 2025-12-11
      validateIDCard7: "Contact email cannot be empty！",
      // 供应商名称不能为空！ 2025-12-11
      validateIDCard8: "Supplier name cannot be empty！",
      title: "Puzzle verification", // 拼图验证
      title1: "Change one", // 换一张
      title2: "Puzzle loading in progress", // 拼图加载中
      title3: "Swipe right to complete the puzzle", // 向右滑动完成拼图
      title4: "Send verification code" // 发送验证码
    }
  }
};
